import { Code as Key } from 'constants/keyboard';
import { WidgetType } from 'types/widget.types';

import { KeyboardOvverride, WIDGET_SHORTCUT_CONFIG } from './KeyboardShortcut.config';

export const hasCustomWidgetKeyOverride = (key: Key, activeWidgetType: WidgetType | undefined): boolean => {
  if (!activeWidgetType) return false;
  if (!WIDGET_SHORTCUT_CONFIG?.[activeWidgetType]) return false;

  const { all, excludeSpecific } = WIDGET_SHORTCUT_CONFIG[activeWidgetType] as KeyboardOvverride;

  if (all) return true;
  if (excludeSpecific && excludeSpecific.includes(key)) return true;

  return false;
};

/**
 * Check if the keyboard target element is a drag element for the colorpicker (e.g. saturation slider)
 *
 * @param target The target element of the keyboard event
 */
export const allowColorPickerDragElements = (target: HTMLElement) => {
  if (target.className.includes('react-colorful')) return false;
};
